import React from 'react';
import ContentLoader from 'react-content-loader';
import theme from 'src/shared/theme';

export const QueryDialogResultsLoader = () => (
    <ContentLoader speed={2} width='100%' height='400px' backgroundColor={theme.skeleton.backgroundColor} foregroundColor={theme.skeleton.foregroundColor}>
        {new Array(5).fill(0).map((x, idx) => (
            <rect key={idx} x='0' y={idx * (37 + 10)} rx='10' ry='10' width='100%' height='37' />
        ))}
    </ContentLoader>
);
